export default __webpack_public_path__ + "static/media/habi.07d4cf21.svg";